import React from "react";
import { TFunction } from "i18next";
import classnames from "classnames";
import { useDispatch } from "react-redux";

import { CustomCardFooter } from "@components/Common/CustomCardStyled";
import { CustomMainColorButton } from "@components/Common/CustomMainColorButton";
import { CustomSecondaryColorButton } from "@components/Common/CustomSecondaryColorButton";
import { clearData } from "@components/Common/MultiCustomCreatableSelection/store";
import { clearMultiCustomSelectionData } from "@components/Common/MultiCustomSelect/store";
import { CESAR_LOYALTY } from "@constants/index";

import { AppDispatch } from "../../../../../../redux/store";
import {
    setIsActionsClicked,
    setIsEdited,
} from "../../../../../../redux/slices/fidelitySlice";
import { useFidelityNavigationGuard } from "../../../FidelityNavigationGuardContext";

type Props = {
    isEdited: boolean;
    isActionsClicked: boolean;
    isAddFidelityClicked: boolean;
    isConsult: boolean;
    isValidateButtonEnabled: boolean;
    oneShop: boolean;
    fidelityChoiceIndex: number;
    onValidate: () => void;
    setIsAddFidelityClicked: (v: boolean) => void;
    setDataFidelity: (rows: FidelityRow[]) => void;
    setDataIsUpdated: (v: boolean) => void;
    setIsConsult: (v: boolean) => void;
    t: TFunction;
};

export default function FormFooter({
    isEdited,
    isActionsClicked,
    isAddFidelityClicked,
    isConsult,
    isValidateButtonEnabled,
    oneShop,
    fidelityChoiceIndex,
    onValidate,
    setIsAddFidelityClicked,
    setDataFidelity,
    setDataIsUpdated,
    setIsConsult,
    t,
}: Props) {
    const dispatch = useDispatch<AppDispatch>();
    const { setOnConfirm } = useFidelityNavigationGuard();
    const handleCancel = () => {
        if (isEdited) {
            dispatch(setIsActionsClicked(!isActionsClicked));
            setOnConfirm(() => {
                dispatch(setIsEdited(false));
                setIsAddFidelityClicked(!isAddFidelityClicked);
                clearMultiCustomSelectionData();
                clearData();
                setDataFidelity([]);
                setDataIsUpdated(true);
            });
        } else {
            setIsAddFidelityClicked(!isAddFidelityClicked);
            dispatch(setIsEdited(false));
        }
        setIsConsult(false);
    };

    const validateClassName = classnames(
        "fed_btn_FRvalidate cmn_btn_validate",
        {
            "not-allowed-input__clz":
                isConsult || (oneShop && fidelityChoiceIndex === CESAR_LOYALTY),
        }
    );

    return (
        <CustomCardFooter className="pt-1 pb-2">
            <CustomSecondaryColorButton
                data-testid="fidelity-franchise-form-cancel-button"
                outline
                rounded
                className="mr-2 fed_btn_FRcancel cmn_btn_cancel"
                variant="light"
                onClick={handleCancel}
            >
                <span>{t("Cancel")}</span>
            </CustomSecondaryColorButton>
            <CustomMainColorButton
                data-testid="fidelity-franchise-form-validate-button"
                rounded
                variant="primary"
                className={validateClassName}
                disabled={!isValidateButtonEnabled}
                onClick={onValidate}
            >
                {t("Validate")}
            </CustomMainColorButton>
        </CustomCardFooter>
    );
}
